module.exports = __webpack_public_path__ + "static/img/sub-banner-bj.6433021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub-banner-bj.png
// module id = L0mz
// module chunks = 1